// extracted by mini-css-extract-plugin
export default {"back_button":"BackButton_back_button__6VM5B"};